<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-12 pb-0" style="display: flex; justify-content: center">
          <h4 class="mb-0">Horario de Agentes (Vista supervisor)</h4>
        </div>
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="3" class="pa-1 mx-2">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="begin"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :title-date-format="titleDateFormat"
                        :min="this.allowedDates"
                        :max="this.allowedDates2"
                        v-model="begin"
                        locale="es"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="handleClick(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idencargado"
                      label="MU"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idfirmarse_sistema"
                      label="Agente"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-title>
            <v-data-table
              id="containers"
              :items="items"
              :search="search"
              hide-default-headers
              class="locked-columns-table elevation-1"
              :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [5, 10, 20, -1] }"
              :items-per-page="10"
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-if="this.$vuetify.breakpoint.smAndUp" v-slot:header="{ header }">
                <thead>
                  <tr>
                    <th class="locked-column" style="background-color: #f5f5f5">{{ "Login Agente" }}</th>
                    <th class="locked-column__second" style="background-color: #f5f5f5">{{ "Nombre Agente" }}</th>
                    <th class="locked-column__third" style="background-color: #f5f5f5">{{ "Pendientes" }}</th>

                    <th class="px-0" style="display: flex; height: 64px !important">
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center"></div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "01:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "02:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "03:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "04:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "05:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "06:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "07:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "08:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "09:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "10:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "11:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "12:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "13:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "14:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "15:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "16:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "17:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "18:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "19:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "20:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "21:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "22:00" }}</div>
                      </div>
                      <div style="width: 50px; height: 64px; display: flex; align-items: center; justify-content: center">
                        <div class="calendar__headers">{{ "23:00" }}</div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-if="this.$vuetify.breakpoint.smAndUp" v-slot:item="{ item }">
                <tr>
                  <td @click="detail(item)" class="locked-column" style="cursor: pointer">
                    {{ item.idfirmarseSistema }}
                  </td>
                  <td @click="detail(item)" class="locked-column__second" style="cursor: pointer">{{ item.nomagenteSistema }}</td>
                  <td @click="detail(item)" class="locked-column__third" style="cursor: pointer">
                    <div
                      style="border-bottom: thin solid rgb(255 255 255 / 12%)"
                      v-if="
                        item.ausencia_en_proceso.length === 0 &&
                        item.oferta_en_proceso.length === 0 &&
                        item.intercambio_en_proceso.length === 0
                      "
                    >
                      No hay pendientes
                    </div>
                    <div v-else style="border-bottom: thin solid rgb(255 255 255 / 12%); display: flex; align-items: center">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.ausencia_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-window-close
                          </v-icon>
                        </template>
                        <span>Ausencia</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.oferta_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-bullhorn
                          </v-icon>
                        </template>
                        <span>Oferta</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.intercambio_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-people-carry
                          </v-icon>
                        </template>
                        <span>Intercambio</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="px-0" style="display: flex; height: 64px !important; position: relative">
                    <div
                      v-for="(item, idx) in item.eventos"
                      :key="idx"
                      class="d-flex align-center"
                      :style="{ 'margin-left': item.margin + 'px' }"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            class="ma-0"
                            :style="{ width: item.width + 'px', 'font-size': '12px', 'font-weight': '600', 'z-index': '4' }"
                            :class="{ 'color-secondary': item.idactividad === 'Open', 'color-primary': item.idactividad === 'Lunch' }"
                          >
                            {{ item.idactividad + " " + item.horaInicioActividad + " - " + item.horaFinActividad }}
                          </v-chip>
                        </template>
                        <span> {{ item.idactividad + " " + item.horaInicioActividad + " - " + item.horaFinActividad }}</span>
                      </v-tooltip>
                    </div>
                    <div v-for="index in 23" :key="index" class="vertical-line" :style="{ left: index * 50 + 'px' }"></div>
                  </td>
                </tr>
              </template>
              <template v-else v-slot:item="{ item }">
                <tr class="mobile-tr">
                  <td
                    class="mobile-td"
                    style="min-height: 48px; display: flex; justify-content: space-between; align-items: center; border-bottom: none"
                  >
                    <div class="mobile-header">{{ "Login Agente" }}</div>
                    <div>{{ item.idfirmarseSistema }}</div>
                  </td>
                  <td class="mobile-td">
                    <div class="mobile-header">{{ "Nombre Agente" }}</div>
                    <div>
                      {{ item.nomagenteSistema }}
                    </div>
                  </td>
                  <td class="mobile-td" style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important">
                    <div class="mobile-header">{{ "Pendientes" }}</div>
                    <div
                      v-if="
                        item.ausencia_en_proceso.length === 0 &&
                        item.oferta_en_proceso.length === 0 &&
                        item.intercambio_en_proceso.length === 0
                      "
                    >
                      No hay pendientes
                    </div>
                    <div v-else>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.ausencia_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-window-close
                          </v-icon>
                        </template>
                        <span>Ausencia</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.oferta_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-bullhorn
                          </v-icon>
                        </template>
                        <span>Oferta</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :disabled="item.intercambio_en_proceso.length === 0"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                            size="22"
                            color="#b600cd"
                            style="height: 22px"
                            dark
                          >
                            fas fa-people-carry
                          </v-icon>
                        </template>
                        <span>Intercambio</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:[`footer.page-text`]="props">
                Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralMixin from "@/components/mixins/General";
import axios from "axios";
import moment from "moment-timezone";

export default {
  mixins: [GeneralMixin],
  components: {},
  data() {
    return {
      url: process.env.VUE_APP_URL,
      send: {
        idencargado: "",
        idfirmarse_sistema: "",
      },
      modalBegin: false,
      search: "",
      loading: "",
      result: "d-none",
      maxPages: 1000,
      begin: new Date(),
      items: [],
      allowedDates: "",
      allowedDates2: "",
    };
  },
  methods: {
    Listo() {
      var that = this;
      this.loading = "d-none";
      this.result = "";
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        this.begin = moment.tz(this.date, "UTC").local().format("YYYY-MM-DD");
        const url = this.url + "v2/api/admin/supervisores/calendario/general";

        let data = {
          fecha: this.begin,
          // fecha: "2023-02-08",
        };
        const { data: items } = await axios.post(url, { data });

        this.items = items;
        // this.items = [
        //   {
        //     idagente: 73032,
        //     idagenteSistema: "4440477",
        //     email: "",
        //     password: "2e247e2eb505c42b362e80ed4d05b078",
        //     idfirmarseSistema: "garciaalvarado.21",
        //     nomagenteSistema: "Garcia Alvarado, Abril",
        //     identidadSistema: "",
        //     nomentidadSistema: "",
        //     celular: "",
        //     idencargado: "1124400",
        //     status: 1,
        //     calendario: [
        //       {
        //         idevento: 2615247,
        //         idagente: 73032,
        //         idagenteSistema: 4440477,
        //         idactividad: "Open",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "19:45",
        //         horaInicioActividad: "17:00",
        //         status: 1,
        //         margin: 0,
        //       },
        //       {
        //         idevento: 2615248,
        //         idagente: 73032,
        //         idagenteSistema: 4440477,
        //         idactividad: "Open",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "13:00",
        //         horaInicioActividad: "07:30",
        //         status: 1,
        //       },
        //       {
        //         idevento: 26152348,
        //         idagente: 73032,
        //         idagenteSistema: 4440477,
        //         idactividad: "Lunch",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "15:30",
        //         horaInicioActividad: "13:00",
        //         status: 1,
        //         margin: 0,
        //       },
        //     ],
        //     ausencia_en_proceso: [
        //       {
        //         hora_inicio_evento: "09:00",
        //         hora_fin_evento: "18:00",
        //         fecha_wfm_evalua: null,
        //         idagente: 73032,
        //       },
        //     ],
        //     intercambio_en_proceso: [{}],
        //     oferta_en_proceso: [
        //       {
        //         hora_inicio_evento: "11:30:00",
        //         hora_fin_evento: "14:00:00",
        //         fecha_wfm_evalua: null,
        //         idagente: 73032,
        //       },
        //     ],
        //   },
        //   {
        //     idagente: 73031,
        //     idagenteSistema: "4440477",
        //     email: "",
        //     password: "2e247e2eb505c42b362e80ed4d05b078",
        //     idfirmarseSistema: "carreonguajardo",
        //     nomagenteSistema: "Garcia Alvarado, Abril",
        //     identidadSistema: "",
        //     nomentidadSistema: "",
        //     celular: "",
        //     idencargado: "1124400",
        //     status: 1,
        //     calendario: [
        //       {
        //         idevento: 2615247,
        //         idagente: 73031,
        //         idagenteSistema: 4440477,
        //         idactividad: "Open",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "20:00",
        //         horaInicioActividad: "19:30",
        //         status: 1,
        //         margin: 0,
        //       },
        //       {
        //         idevento: 2615248,
        //         idagente: 73031,
        //         idagenteSistema: 4440477,
        //         idactividad: "Open",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "13:00",
        //         horaInicioActividad: "06:30",
        //         status: 1,
        //       },
        //       {
        //         idevento: 26152348,
        //         idagente: 73031,
        //         idagenteSistema: 4440477,
        //         idactividad: "Lunch",
        //         fechaInicioHorario: "2023-02-08",
        //         fechaActividad: "2023-02-08",
        //         horaFinActividad: "15:00",
        //         horaInicioActividad: "13:00",
        //         status: 1,
        //         margin: 0,
        //       },
        //     ],
        //     ausencia_en_proceso: [
        //       {
        //         hora_inicio_evento: "09:00",
        //         hora_fin_evento: "18:00",
        //         fecha_wfm_evalua: null,
        //         idagente: 73031,
        //       },
        //     ],
        //     intercambio_en_proceso: [{}],
        //     oferta_en_proceso: [
        //       {
        //         hora_inicio_evento: "11:30:00",
        //         hora_fin_evento: "14:00:00",
        //         fecha_wfm_evalua: null,
        //         idagente: 73031,
        //       },
        //     ],
        //   },
        // ];

        if (this.items.length > 0) {
          this.items.forEach((item, idx) => {
            const calendario = item.calendario.slice().sort((a, b) => a.horaInicioActividad.localeCompare(b.horaInicioActividad));
            const primerEvento = calendario[0];
            const primerosDosDigitos = parseInt(primerEvento.horaInicioActividad.substring(0, 2), 10);
            const ultimosDosDigitos = parseInt(primerEvento.horaInicioActividad.substring(3, 6), 10);
            primerEvento.margin = (primerosDosDigitos / 2) * 100 + (ultimosDosDigitos / 3) * 2.5;

            calendario.forEach((evento, index) => {
              const [inicioHoras, inicioMinutos] = evento.horaInicioActividad.split(":");
              const [finHoras, finMinutos] = evento.horaFinActividad.split(":");

              const fechaInicio = new Date();
              fechaInicio.setHours(parseInt(inicioHoras, 10));
              fechaInicio.setMinutes(parseInt(inicioMinutos, 10));

              const fechaFin = new Date();
              fechaFin.setHours(parseInt(finHoras, 10));
              fechaFin.setMinutes(parseInt(finMinutos, 10));

              const diferenciaMilisegundos = fechaFin - fechaInicio;
              const diferenciaHoras = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60));
              const diferenciaMinutos = Math.floor((diferenciaMilisegundos / (1000 * 60)) % 60);

              evento.width = diferenciaHoras * 50 + (diferenciaMinutos / 3) * 2.5;

              if (index > 0) {
                const [finHoras, finMinutos] = calendario[index - 1].horaFinActividad.split(":");

                const fechaFin = new Date();
                fechaFin.setHours(parseInt(finHoras, 10));
                fechaFin.setMinutes(parseInt(finMinutos, 10));

                const diferenciaMilisegundos = fechaFin - fechaInicio;
                const diferenciaHoras = Math.abs(Math.floor(diferenciaMilisegundos / (1000 * 60 * 60)));
                const diferenciaMinutos = Math.abs(Math.floor((diferenciaMilisegundos / (1000 * 60)) % 60));

                evento.margin = diferenciaHoras * 50 - (diferenciaMinutos / 3) * 2.5;
              }
            });
            item.eventos = calendario;
          });
        }

        if (this.items.length === 0) {
          swal("No hay datos", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },
    detail(item) {
      this.$router.push({
        name: "Supervisores_Detail",
        params: { id: item.idfirmarseSistema },
      });
    },
    handleClick(begin) {
      this.$refs.dialogBegin.save(begin);
      this.Consultar();
    },
  },
  computed: {
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fecha seleccionada");
      };
    },
  },
  created() {
    this.Listo();
    this.Consultar();
    var dateFrom = moment(dateFrom).subtract(1, "week").format("YYYY-MM-DD");
    var dateFrom2 = moment(dateFrom2).add(1, "week").format("YYYY-MM-DD");
    this.allowedDates = dateFrom;
    this.allowedDates2 = dateFrom2;
  },
};
</script>

<style>
.locked-columns-table .locked-column {
  position: sticky;
  left: 0;
  background-color: #f5f5f5;
  z-index: 3;
  min-width: 108px;
  max-width: 108px;
}
.locked-columns-table .locked-column__second {
  position: sticky;
  left: 108px;
  background-color: #f5f5f5;
  z-index: 3;
  min-width: 108px;
  max-width: 108px;
}
.locked-columns-table .locked-column__third {
  position: sticky;
  left: 216px;
  background-color: #f5f5f5;
  z-index: 3;
}
.column-border__right {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.mobile-tr {
  display: flex;
  flex-direction: column;
}
.mobile-td {
  min-height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none !important;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(69 69 69 / 50%) !important;
}
.calendar__headers {
  display: block;
  position: relative;
  left: -23px;
  font-size: 10px;
  padding-right: 4px;
}
.color-primary {
  color: white !important;
  background-color: #00d0ff !important;
}
.color-secondary {
  color: white !important;
  background-color: #005eff !important;
}
.vertical-line {
  position: absolute; /* Cambia a "fixed" si deseas una posición fija en la ventana */
  z-index: 2;
  width: 0.1px;
  height: 100px; /* Ajusta la altura según sea necesario */
  background-color: #cacaca; /* Cambia el color de la línea si lo deseas */
  margin: 0 auto; /* Centra la línea horizontalmente */
}
</style>
